import { useContext } from 'react';
import { AssetDto, UserSpoolDto } from '../../../../types/spool-local';
import modalContext from '../../../../context/modal/modalContext';
import { NotificationIcon } from '../../../../assets/icons';
import { formatUSD } from '../../../../helpers/formats';
import Button from '../../../Button';
import InfoPopUp from '../../../InfoPopUp';
import { useWeb3React } from '@web3-react/core';
import { SupportedChains } from '../../../../config/constants';

type Props = {
    userSpool: UserSpoolDto | undefined;
    asset: AssetDto;
    claimWithdraw: () => void;
};

const WithdrawalStatus: React.FC<Props> = ({ userSpool, asset, claimWithdraw }) => {
    const { openModal } = useContext(modalContext);
    const { chainId } = useWeb3React();

    return (
        <div className='withdrawal-status'>
            {userSpool?.userClaimableAmount ? (
                <div className='withdrawal-ready'>
                    <div className='title'>
                        <NotificationIcon />
                        <span>Ready to Withdraw</span>
                    </div>
                    <div className='amount'>
                        {formatUSD(userSpool?.userClaimableAmount || 0)}{' '}
                        {asset?.symbol ?? 'XXX'}
                    </div>
                    <Button onClick={claimWithdraw}>Claim Withdrawal</Button>
                </div>
            ) : null}
            <div className='current-balance'>
                <div className='title'>
                    <span>Your Current Balance in this Spool</span>
                    <InfoPopUp>
                        Your Pending deposits will be added to your current balance in
                        this Spool when the next Do Hard Work is executed. Generally
                        within{' '}
                        {chainId === SupportedChains.ARBITRUM_ONE ? '24 hours' : '3 days'}
                        . Final values may vary slightly due to small variations in
                        slippage.
                    </InfoPopUp>
                </div>
                <div className='balance'>
                    {userSpool?.userCurrentBalance
                        ? `${formatUSD(userSpool?.userCurrentBalance || 0)}
                    ${asset?.symbol ?? 'XXX'}`
                        : 'N/A'}
                </div>
            </div>
            <Button
                variant='secondary'
                onClick={() => openModal('withdrawalMethod')}
                disabled={!userSpool?.userCurrentBalance}
                className='withdraw'
            >
                Withdraw
            </Button>

            <div className='pending-amount'>
                <div className='withdrawal-pending'>
                    <div className='title'>
                        <span>Withdrawal Pending</span>
                        <InfoPopUp>
                            If you have Pending Withdrawals, they will be available to
                            claim after the next Do Hard Work, generally within{' '}
                            {chainId === SupportedChains.ARBITRUM_ONE
                                ? '24 hours'
                                : '3 days'}
                            . Final amounts may differ due to small variations in
                            slippage.
                            <br />
                            <br />
                            If your Pending balance has not been updated, refresh the page
                            manually.
                        </InfoPopUp>
                    </div>
                    <div className='amount'>
                        {formatUSD(userSpool?.pendingWithdrawalAmount || 0)}{' '}
                        {asset?.symbol ?? 'XXX'}
                    </div>
                </div>
                <div className='deposit-pending'>
                    <div className='title'>
                        <span>Deposit Pending</span>
                        <InfoPopUp>
                            If you have Pending Deposits, they will arrive in your Spool
                            after the next Do Hard Work, generally within{' '}
                            {chainId === SupportedChains.ARBITRUM_ONE
                                ? '24 hours'
                                : '3 days'}
                            . Final amounts may differ due to small variations in
                            slippage.
                            <br />
                            <br />
                            If your Pending balance has not been updated, refresh the page
                            manually.
                        </InfoPopUp>
                    </div>
                    <div className='amount'>
                        {formatUSD(userSpool?.pendingDepositAmount || 0)}{' '}
                        {asset?.symbol ?? 'XXX'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WithdrawalStatus;
